module.exports = __webpack_public_path__ + "static/media/alif.6af7fb4a.jpeg";